module.exports = __webpack_public_path__ + "img/sanren.e60f18bd.jpg";